/**
 * =========================================================================================
 *   Copyright © 2026 Dobler Data Solutions, LLC. ALL RIGHTS RESERVED.
 * =========================================================================================
 *   Module       : components/errors/GlobalBackupErrorDrawer
 *   Feature      : 252 - Backup Error Visibility & Guided Remediation
 *   Description  : ONE app-wide mount of the error drawer (mirrors GlobalBackupActivityDrawer),
 *                  so an alert clicked from the header bell or /alerts can open the error detail
 *                  from anywhere. Without this, an alert deep-link would be a dead end (FR-008).
 *   Author       : Peter Dobler (Dobler Data Solutions)
 * =========================================================================================
 */
import React from 'react';
import ErrorDetailDrawer from './ErrorDetailDrawer';
import useBackupErrorDrawer from '../../store/backupErrorStore';

export const GlobalBackupErrorDrawer: React.FC = () => {
  const errorKey = useBackupErrorDrawer((s) => s.errorKey);
  const runId = useBackupErrorDrawer((s) => s.runId);
  const close = useBackupErrorDrawer((s) => s.close);
  return <ErrorDetailDrawer errorKey={errorKey} runId={runId} onClose={close} />;
};

export default GlobalBackupErrorDrawer;
